import { render, staticRenderFns } from "./UserSettingsChangePassword.vue?vue&type=template&id=67200e33&scoped=true&"
import script from "./UserSettingsChangePassword.vue?vue&type=script&lang=js&"
export * from "./UserSettingsChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./UserSettingsChangePassword.vue?vue&type=style&index=0&id=67200e33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67200e33",
  null
  
)

export default component.exports